
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 lg:px-16">
        <div className="flex items-center justify-between h-20">
          {/* Left Navigation */}
          <div className="flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-lato tracking-wider transition-colors whitespace-nowrap ${
                isScrolled ? 'text-charcoal hover:text-burgundy' : 'text-white/90 hover:text-white'
              } ${isActive('/') ? 'font-bold' : ''}`}
            >
              HOME
            </Link>
            <Link
              to="/books"
              className={`text-sm font-lato tracking-wider transition-colors whitespace-nowrap ${
                isScrolled ? 'text-charcoal hover:text-burgundy' : 'text-white/90 hover:text-white'
              } ${isActive('/books') ? 'font-bold' : ''}`}
            >
              BOOKS
            </Link>
            <Link
              to="/gallery"
              className={`text-sm font-lato tracking-wider transition-colors whitespace-nowrap ${
                isScrolled ? 'text-charcoal hover:text-burgundy' : 'text-white/90 hover:text-white'
              } ${isActive('/gallery') ? 'font-bold' : ''}`}
            >
              GALLERY
            </Link>
          </div>

          {/* Center Logo */}
          <Link to="/" className="flex flex-col items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/d9f5d46e-c4c8-4bf2-a27c-d51b8e61ed75.png" 
              alt="Susan Gitelson Logo" 
              className="h-12 w-auto object-contain"
            />
          </Link>

          {/* Right Navigation */}
          <div className="flex items-center gap-8">
            <Link
              to="/about"
              className={`text-sm font-lato tracking-wider transition-colors whitespace-nowrap ${
                isScrolled ? 'text-charcoal hover:text-burgundy' : 'text-white/90 hover:text-white'
              } ${isActive('/about') ? 'font-bold' : ''}`}
            >
              ABOUT
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-lato tracking-wider transition-colors whitespace-nowrap ${
                isScrolled ? 'text-charcoal hover:text-burgundy' : 'text-white/90 hover:text-white'
              } ${isActive('/contact') ? 'font-bold' : ''}`}
            >
              CONTACT
            </Link>
            <a
              href="#newsletter"
              className={`px-6 py-2 rounded-full text-sm font-lato tracking-wider transition-all whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-burgundy text-cream hover:bg-burgundy/90'
                  : 'bg-cream text-charcoal hover:bg-white'
              }`}
            >
              NEWSLETTER
            </a>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
